import React from 'react'
import { useAuth } from '../../../../hooks/useAuth'
import { postStatuses } from '../../Post'
import { ReactComponent as PostCompleteIcon } from './../complete-icon.svg'

const PublishedPostLabel = ({ status, subCategoryTitle, subCategories, requestInvoice, completeProject }) => {

    const {
        isAdmin
    } = useAuth()

    const handleRequestClick = e => {
        e.stopPropagation()
        requestInvoice()
    }

    const handleCompleteButtonClick = e => {
        e.stopPropagation()
        completeProject()
    }

    return (
        <>
            {
                subCategoryTitle === subCategories.publishedInProgress &&
                (!isAdmin ||
                (status === postStatuses.requestInvoice && isAdmin)) &&
                <div className='post-complete-button' onClick={handleCompleteButtonClick}>
                    <PostCompleteIcon />
                    <span>Complete</span>
                </div>
            }
            {
                subCategoryTitle === subCategories.publishedInProgress
                && status === postStatuses.inProgress
                && isAdmin
                && <div className='post-request-invoice-button' onClick={handleRequestClick}>
                    Request Invoice
                </div>
            }
        </>
    )
}

export default PublishedPostLabel